import { GTMPush } from '@utilities/gtm';

const GTM_DEBUG = false;

interface Collection {
    type: 'gas' | 'city heating';
    supplyKnowledge: 'yes' | 'no';
    supplyUsageGas?: string;
    supplyUsageHeat?: string;
    houseDetailsType?: string;
    houseDetailsBuildYear?: string;
    houseDetailsSize?: string;
    electricKnowledge: 'yes' | 'no';
    electricUsage?: string;
    residents?: string;
    interestedHouse: string;
}

const collection: Collection = {
    type: 'gas',
    supplyKnowledge: 'yes',
    electricKnowledge: 'yes',
    interestedHouse: '',
};

export function setupEnergyCostGTM(element: HTMLDivElement) {
    const gtmInit = setInterval(() => {
        const gtmElement = element.querySelector('#wnmdl-pagination > li');
        if (gtmElement) {
            clearInterval(gtmInit);
            measureEnergyCostGTM(element);
        }
    }, 200);
}

function measureEnergyCostGTM(element: HTMLDivElement) {
    const pagination = element.querySelectorAll<HTMLUListElement>('#wnmdl-pagination > li');
    const btn = element.querySelector<HTMLAnchorElement>('#wnmdl-btn-next');
    const form = element.querySelector<HTMLFormElement>('#wnmdl-form');
    let currentStep = 1;

    pagination?.forEach((button: HTMLElement) => {
        button.addEventListener('click', (e) => {
            const el = e.target as HTMLElement;
            if (el.classList.contains('disabled')) return;

            const dataIndex = el ? el.getAttribute('data-index') : '1';
            currentStep = dataIndex ? parseInt(dataIndex) + 1 : 1;
        });
    });

    btn?.addEventListener(
        'click',
        () => {
            setTimeout(() => {
                const errorState: Boolean = hasError();
                if (!errorState) {
                    handleStep(currentStep);
                    currentStep++;
                }
            }, 0);
        },
        { capture: true },
    );
    form?.addEventListener(
        'change',
        () => {
            const formData = new FormData(form).entries();
            for (const item of formData) {
                const [key, value] = item;

                switch (key) {
                    case 'energiesoort': {
                        if (GTM_DEBUG) console.info('> energiesoort', value);
                        if (value === 'gas') {
                            collection.type = 'gas';
                        } else {
                            collection.type = 'city heating';
                        }
                        break;
                    }
                    case 'energieverbruikmodus': {
                        if (GTM_DEBUG) console.info('> energieverbruikmodus', value);
                        collection.houseDetailsType = '';
                        collection.houseDetailsBuildYear = '';
                        collection.houseDetailsSize = '';
                        collection.supplyUsageGas = '';
                        collection.supplyUsageHeat = '';
                        if (value === '1') {
                            collection.supplyKnowledge = 'yes';
                        } else {
                            collection.supplyKnowledge = 'no';
                        }
                        break;
                    }
                    case 'warmteverbruik': {
                        if (GTM_DEBUG) console.info('> warmteverbruik', value);
                        collection.supplyUsageHeat = `${value}`;
                        break;
                    }
                    case 'gasverbruik': {
                        if (GTM_DEBUG) console.info('> gasverbruik', value);
                        collection.supplyUsageGas = `${value}`;
                        break;
                    }
                    case 'woningtype': {
                        if (GTM_DEBUG) console.info('> woningtype', value);
                        houseType(value as string);
                        break;
                    }
                    case 'bouwjaar': {
                        if (GTM_DEBUG) console.info('> bouwjaar', value);
                        houseBuildYear(value as string);
                        break;
                    }
                    case 'woonoppervlak': {
                        if (GTM_DEBUG) console.info('> woonoppervlak', value);
                        houseSize(value as string);
                        break;
                    }
                    case 'elektraverbruikmodus': {
                        if (GTM_DEBUG) console.info('> elektraverbruikmodus', value);
                        if (value === '1') {
                            collection.electricKnowledge = 'yes';
                        } else {
                            collection.electricKnowledge = 'no';
                        }
                        break;
                    }
                    case 'elektraverbruik': {
                        if (GTM_DEBUG) console.info('> elektraverbruik', value);
                        collection.electricUsage = `${value}`;
                        break;
                    }
                    case 'bewoners': {
                        if (GTM_DEBUG) console.info('> bewoners', value);
                        residents(value as string);
                        break;
                    }
                    case 'bouwnummer': {
                        if (GTM_DEBUG) console.info('> bouwnummer', value);
                        collection.interestedHouse = `${value}`;
                        break;
                    }
                }
            }
        },
        { capture: true },
    );
}

function handleStep(currentStep: number) {
    switch (currentStep) {
        case 1: {
            datalayerPush(collection.type, '', '', getStepTitle(1));
            break;
        }
        case 2: {
            const {
                supplyKnowledge,
                type,
                supplyUsageGas,
                supplyUsageHeat,
                houseDetailsType,
                houseDetailsBuildYear,
                houseDetailsSize,
            } = collection;
            const supplyUsage = collection.type === 'gas' ? supplyUsageGas : supplyUsageHeat;

            const supplyDetails =
                supplyKnowledge === 'yes'
                    ? supplyUsage
                    : `${houseDetailsType}_${houseDetailsBuildYear}_${houseDetailsSize}`;

            datalayerPush(type, supplyKnowledge, supplyDetails || '', getStepTitle(2, { type }));
            break;
        }
        case 3: {
            const {
                electricKnowledge,
                electricUsage,
                houseDetailsType,
                houseDetailsSize,
                residents,
            } = collection;
            let supplyDetails = '';

            if (electricKnowledge === 'yes') {
                supplyDetails = electricUsage || '';
            } else if (houseDetailsType && houseDetailsSize && residents) {
                supplyDetails = `${houseDetailsType}_${houseDetailsSize}_${residents}`;
            } else if (residents) {
                supplyDetails = residents;
            }

            datalayerPush('electricity', electricKnowledge, supplyDetails, getStepTitle(3));
            break;
        }
        case 4: {
            datalayerPush('house interest', '', collection.interestedHouse, getStepTitle(4));
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'gtm.virtualPageview',
                virtualURL: '/energiecalculator/details',
                virtualTitle: 'Energiecalculator - Details',
            });
            datalayerPush('house interest', '', collection.interestedHouse, getStepTitle(5));
            if (GTM_DEBUG) console.info('final push done');
            break;
        }
    }
}

function getStepTitle(step: number, options?: { type?: string }) {
    switch (step) {
        case 1: {
            return '1. Welk type warmtelevering gebruik je in je huidige woning?';
        }
        case 2: {
            return options?.type === 'gas'
                ? '2. Weet je jouw huidige gasverbruik?'
                : '2. Weet je jouw huidige warmteverbruik?';
        }
        case 3: {
            return '3. Weet je jouw huidige elektriciteitsverbruik?';
        }
        case 4: {
            return '4. In welke nieuwe woning heb je interesse?';
        }
        default: {
            return 'Energiebesparing berekend.';
        }
    }
}

function houseSize(value: string) {
    switch (value) {
        case '1': {
            collection.houseDetailsSize = '15-tot-50-m²';
            break;
        }
        case '2': {
            collection.houseDetailsSize = '50-tot-75-m²';
            break;
        }
        case '3': {
            collection.houseDetailsSize = '75-tot-100-m²';
            break;
        }
        case '4': {
            collection.houseDetailsSize = '100-tot-150-m²';
            break;
        }
        case '5': {
            collection.houseDetailsSize = '150-tot-250-m²';
            break;
        }
        case '6': {
            collection.houseDetailsSize = '250-tot-500-m²';
            break;
        }
    }
}

function residents(value: string) {
    switch (value) {
        case '1': {
            collection.residents = '1-persoon';
            break;
        }
        case '5': {
            collection.residents = '5-of-meer';
            break;
        }
        default: {
            collection.residents = `${value}-personen`;
            break;
        }
    }
}

function houseBuildYear(value: string) {
    switch (value) {
        case '1': {
            collection.houseDetailsBuildYear = '1945-of-eerder';
            break;
        }
        case '2': {
            collection.houseDetailsBuildYear = '1946-en-1964';
            break;
        }
        case '3': {
            collection.houseDetailsType = '1965-en-1974';
            break;
        }
        case '4': {
            collection.houseDetailsBuildYear = '1975-en-1991';
            break;
        }
        case '5': {
            collection.houseDetailsBuildYear = '1992-en-1999';
            break;
        }
        case '6': {
            collection.houseDetailsBuildYear = '2000-en-2013';
            break;
        }
        case '7': {
            collection.houseDetailsBuildYear = '2014-of-later';
            break;
        }
    }
}

function houseType(value: string) {
    switch (value) {
        case '1': {
            collection.houseDetailsType = 'appartement';
            break;
        }
        case '2': {
            collection.houseDetailsType = 'hoekwoning';
            break;
        }
        case '3': {
            collection.houseDetailsType = '2-onder-1-kapwoning';
            break;
        }
        case '4': {
            collection.houseDetailsType = 'tussenwoning';
            break;
        }
        case '5': {
            collection.houseDetailsType = 'vrijstaande-woning';
            break;
        }
    }
}

function hasError() {
    return !!document.querySelector('.wnmdl-error');
}

function datalayerPush(category: string, action: string, label: string, questionTitle: string) {
    if (GTM_DEBUG) {
        console.info(
            '> -----------------\n',
            `category: ${category}\n action: ${action}\n label: ${label}\n title: ${questionTitle}`,
        );
    }

    GTMPush<DataLayerElement & { title?: string }>({
        event: 'energyCostCalculator',
        eventCategory: category,
        eventAction: action,
        title: questionTitle,
        eventLabel: label,
    });
}
